import React, { FC, useState } from 'react';
import { FixedSizeList as List } from 'react-window';
import { Dropdown, Menu, message, Radio, Input } from 'antd';
import styles from './styles.module.css';
import ToolbarButton from '../ToolbarButton';
import { useOrganizationState } from '../../../../../../clients/providers/Organization';

type Props = {
  selectedProject?: number;
  getContainer: () => HTMLDivElement;
  onChange: (projectId: number) => void;
  disabled: boolean;
};

const BulkMoveToProject: FC<Props> = ({
  getContainer,
  selectedProject,
  onChange,
  disabled
}) => {
  const {
    loading: projectsLoading,
    organization,
    error
  } = useOrganizationState();
  const [visible, setVisible] = useState<boolean>(false);
  const [projectFilter, setProjectFilter] = useState<string>('');

  if (projectsLoading || error || !organization) {
    if (error)
      message.error('Error loading projects, please refresh to try again');
    return null;
  }

  const projects = organization.projects.filter(project =>
    project.name.toLowerCase().includes(projectFilter.toLowerCase())
  );

  return (
    <Dropdown
      disabled={disabled}
      className={styles.moveToProjectDropdown}
      trigger={['click']}
      getPopupContainer={getContainer}
      onOpenChange={setVisible}
      open={visible}
      placement="top"
      arrow={{ pointAtCenter: true }}
      overlayClassName={styles.bulkMoveToProjectOverlay}
      overlay={
        <div className={styles.moveToProjectContainer}>
          <Input
            className={styles.projectListFilter}
            placeholder="Search projects..."
            onChange={event => setProjectFilter(event.target.value)}
          />
          <Menu className={styles.moveToProjectMenu}>
            <Radio.Group name="bulkMoveToProject" value={selectedProject}>
              <List
                height={300} // Adjust height as needed
                itemCount={projects.length}
                itemSize={40} // Adjust row height as needed
                width={320} // Adjust width as needed
              >
                {({ index, style }) => {
                  const { id, name } = projects[index];
                  return (
                    <div style={style} key={id}>
                      <Radio
                        className={styles.moveToProjectMenuItem}
                        value={id}
                        onChange={() => {
                          onChange(id);
                          setTimeout(() => setVisible(false), 400);
                        }}
                      >
                        {name}
                      </Radio>
                    </div>
                  );
                }}
              </List>
            </Radio.Group>
          </Menu>
        </div>
      }
    >
      <ToolbarButton
        active={!!selectedProject}
        open={visible}
        label={'Move to project'.toLowerCase()}
        onClick={() => setVisible(!visible)}
        disabled={disabled}
      />
    </Dropdown>
  );
};

export default BulkMoveToProject;
